// extracted by mini-css-extract-plugin
export default {"errorMessage":"ProfileKidForm_errorMessage__RBZVw","formSection":"ProfileKidForm_formSection__9OGd2","button":"ProfileKidForm_button__OGLNe"};